import styled from 'styled-components';

export const Container = styled.div`
    border-top: 1px solid var(--border);
    width: 100%;
    box-sizing: border-box;
    padding: 16px 20px;
    background: linear-gradient(135deg, var(--peach) 0%, var(--primary) 50%, var(--lavender) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

export const FooterContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    column-gap: 20px;
    row-gap: 4px;
`;

export const FooterLink = styled.span`
    a {
        color: var(--text-link);
        font-size: 0.85em;
        font-weight: 700;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const Copyright = styled.span`
    font-size: 0.75em;
    color: var(--text-primary);
    opacity: 0.8;
`;
